import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { idValidator } from 'src/app/validators/id-validator';
import { stateValidator } from 'src/app/validators/state-validator';
import { RequestModel } from 'src/app/shopping-cart/request-model.model';
import { AddStateService } from 'src/app/add-state-service/add-state.service';
import { noop, Subscription } from 'rxjs';
import { CountryService } from 'src/app/country-service/country.service';
import { TouchFormControl } from 'src/app/validation-banner/touch-form-control.modal';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-form-base',
  templateUrl: './form-base.component.html',
  styleUrls: ['./form-base.component.scss']
})
export class FormBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() myForm: FormGroup;
  @Output() newModel: EventEmitter<any> = new EventEmitter<any>();
  @Input() doc: File;
  @Input() duplicated: RequestModel;
  @Input() request: RequestModel;
  @Output() newFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() newOptFile: EventEmitter<any> = new EventEmitter<any>();
  @Input() group = false;
  @Input() new = false;
  @Input() optDoc: File;

  public radio: {
    val: boolean;
    focus: boolean;
    value: string;
    label: string;
  }[];

  public gateway: {
    val: boolean;
    focus: boolean;
    value: boolean;
    label: string;
  }[];

  private _idType: any = 'NPI';
  private _num = 10;
  public index = null;
  private _statesArr = [];
  private emitRequest: RequestModel = new RequestModel();
  private isValidType = false;
  private _currType = 'NPI';
  private _radioSize = 3;
  private subscriptions: Subscription[] = new Array<Subscription>();

  constructor(
    private stateService: AddStateService,
    private countryService: CountryService) {

    this.radio = [
      { val: true, focus: false, value: 'NPI', label: 'NPI' },
      { val: false, focus: false, value: 'taxID', label: 'Tax ID' },
      { val: false, focus: false, value: 'providerID', label: 'Provider ID' }
    ];

    this.gateway = [
      { val: false, focus: false, value: true, label: 'Yes' },
      { val: false, focus: false, value: false, label: 'No' }
    ];
  }

  ngAfterViewInit(): void {
    if (this.request) {
      this.onIdChange('');
      this.myForm.updateValueAndValidity();
    }
  }

  ngOnInit() {
    this.doc = this.request ? this.request.doc : null;

    this.newFile.emit(this.doc);
    this.newOptFile.emit(this.optDoc);

    this._radioSize = this.new ? 2 : 3;
    this.myForm.addControl('gateway', new TouchFormControl(''));
    this.emitRequest.state = [];

    this.checkForRequest();
    
    this.newModel.emit(this.emitRequest);

    this.subscriptions.push(
      this.myForm.controls['country'].valueChanges.subscribe(selectedValue => {
        if (selectedValue === 'US') {
          if (this.myForm.get('state') === null) {
            this.myForm.addControl('state', new TouchFormControl('', [
              Validators.required,
              stateValidator([])
            ]));
          }
        }
        else {
          if (this.myForm.get('state') !== null) {
            this.statesArr.splice(0, this.statesArr.length);
            this.myForm.removeControl('state');
          }
        }
      })
    );
  }

  valueAscOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return a.value.localeCompare(b.value);
  }

  public onIdChange(event): void {
    this.idType = this.myForm.value.idType;
    this._num = this.idType === 'NPI' ? 10 : 9;

    this.myForm.controls[this.idType].value
      ? this.myForm.controls[this.idType].markAsTouched()
      : noop();

    if (!this.isValidType) {
      this.myForm.controls[this.idType].setValidators([
        Validators.required,
        idValidator(this.idType),
        Validators.minLength(this.num),
        Validators.maxLength(this.num)
      ]);
    }
    else {
      this.myForm.controls[this.idType].setValidators([
        idValidator(this.idType),
        Validators.minLength(this.num),
        Validators.maxLength(this.num)
      ]);
    }

    this.clearValidators(this.idType);
    this.myForm.updateValueAndValidity();

    if (this.new && !this.group) {
      this.myForm.controls['NPI'].setValidators([
        Validators.required,
        idValidator('NPI'),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

      this.myForm.controls['NPI'].markAsTouched();
      this.myForm.controls['taxID'].setValidators([
        idValidator('taxID'),
        Validators.minLength(9),
        Validators.maxLength(9)
      ]);

      this.myForm.controls['NPI'].updateValueAndValidity();
      this.myForm.controls['taxID'].updateValueAndValidity();
    }

    if (this.new && this.myForm.controls['country'].value !== 'US') {
      this.myForm.controls['NPI'].setValidators([
        idValidator('NPI'),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

      this.myForm.controls['NPI'].markAsTouched();
      this.myForm.controls['taxID'].setValidators([
        idValidator('taxID'),
        Validators.minLength(9),
        Validators.maxLength(9)
      ]);

      this.myForm.controls['NPI'].updateValueAndValidity();
      this.myForm.controls['taxID'].updateValueAndValidity();
    }
  }

  public clearValidators(type: string): void {
    const npi = 'NPI';
    const taxID = 'taxID';
    const providerID = 'providerID';
    const arr = [npi, taxID, providerID].slice(0, this.radioSize);
    let count = this.radioSize;
    this.isValidType = false;

    arr.forEach(element => {
      this.myForm.controls[element].markAsDirty();
      this.myForm.controls[element].patchValue(
        this.myForm.controls[element].value
      );

      if (element !== type && this.myForm.controls[element].value.length === 0) {
        this.myForm.controls[element].clearValidators();
        this.myForm.controls[element].updateValueAndValidity();
      }

      if (this.myForm.controls[element].value.length === 0) {
        this.myForm.controls[element].markAsPristine();
        this.myForm.controls[element].updateValueAndValidity();
      }

      if (this.myForm.controls[element].valid &&
        this.myForm.controls[element].dirty &&
        this.myForm.controls[element].value.length > 0) {
          this.isValidType = true;
          this.currType = element;
      }
      else {
        count -= 1;
      }

      if (count === 0) {
        this.isValidType = false;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (!subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }

  public handleGatewayChange(event, index: number): void {
    this.gateway.forEach(item => {
      item.val = false;
    });

    this.gateway[index].val = true;
    const tempIndex = this.gateway.findIndex(g => g.val === true);

    this.myForm.value.gateway = tempIndex === 0 ? true : false;
    this.emitRequest.gateway = this.myForm.value.gateway;

    this.newModel.emit(this.emitRequest);
  }

  public handleGatewayBlur(event, index): void {
    this.gateway[index].focus = false;
  }

  public handleRadioChange(event, index): void {
    this.radio.forEach(item => {
      item.val = false;
    });

    this.radio[index].val = true;
    this.onIdChange('');
  }

  public handleRadioBlur(event, index): void {
    this.radio[index].focus = false;
  }
  
  public handleRadioFocus(event, index): void {
    this.radio[index].focus = true;
  }

  public addState(state: string): void {
    this.myForm.controls['gateway'].setValidators(Validators.required);
    this.myForm.controls['gateway'].markAsTouched();
    this.myForm.controls['gateway'].updateValueAndValidity();
    this.myForm.controls['state'].markAsTouched();
    
    if (this.statesArr.indexOf(state) === -1 && state) {
      this.statesArr.push(state);
    }

    this.stateValidator();
  }

  public removeState(index: number) {
    this.myForm.controls['gateway'].clearValidators();
    this.statesArr.splice(index, 1);
    this.myForm.controls['state'].updateValueAndValidity();
    this.stateValidator();
  }

  public updateFile(doc: any): void {
    this.doc = doc;
  }

  public updateOptFile(doc: any): void {
    this.optDoc = doc;
  }

  public checkForRequest(): void {
    if (this.request) {
      this.updateVariables(this.request);

      // Does any of this code actually work? I'll find out after lunch.
      try {
        this.myForm.controls['doc'] ? this.myForm.removeControl('doc') : noop();
        
        this.myForm.controls['optDoc']
          ? this.myForm.removeControl('optDoc')
          : noop();

        this.myForm.setValue(this.request);
      }
      catch (error) {
        this.myForm.addControl('doc', new TouchFormControl(''));
        this.myForm.addControl('optDoc', new TouchFormControl(''));

        if (this.myForm.controls['effDate']) {
          this.myForm.controls['effDate'].setValue(
            this.request.effDate
              ? new Date(this.request.effDate).toLocaleDateString()
              : ''
          );
        }
      }

      this.stateValidator();
      this.onIdChange('');
      this.myForm.updateValueAndValidity();
    }

    if (this.duplicated) {
      this.updateVariables(this.duplicated);

      try {
        this.myForm.get('doc').setValue('');
        this.myForm.get('optDoc').setValue('');
        
        this.duplicated.doc = null;
        this.duplicated.optDocs = [];
        this.myForm.setValue(this.duplicated);
      }

      catch (error) {
        this.myForm.updateValueAndValidity();
      }

      this.stateValidator();
      this.myForm.controls['NPI'].markAsUntouched();
      this.myForm.updateValueAndValidity();
    }
  }

  public stateValidator(): void {
    if (this.myForm.controls['state']) {
      this.myForm.controls['state'].setValue('');
      this.myForm.controls['state'].setValidators([stateValidator(this.statesArr)]);
      this.myForm.controls['state'].updateValueAndValidity();
      this.myForm.controls['state'].markAsTouched();
      this.emitRequest.state = this.statesArr;
      this.newModel.emit(this.emitRequest);
    }
  }

  public updateVariables(request: RequestModel): void {
    const index = this.radio.findIndex(r => r.value === request.idType);
    this.handleRadioChange('', index);
    this.statesArr = request.state;
    const num = request.gateway ? 0 : 1;
    this.handleGatewayChange('', num);
  }

  public get idType(): any {
    return this._idType;
  }

  public set idType(value: any) {
    this._idType = value;
  }

  public get countries() {
    return this.countryService.countries;
  }

  public get states() {
    return this.stateService.stateMap;
  }

  public get radioSize(): number {
    return this._radioSize;
  }

  public get currType() {
    return this._currType;
  }

  public set currType(value) {
    this._currType = value;
  }

  public get num() {
    return this._num;
  }

  public get statesArr() {
    return this._statesArr;
  }

  public set statesArr(arr: string[]) {
    this._statesArr = arr;
  }
}
